import React from 'react';
import PropTypes from 'prop-types';

const Check = ( { size, color, type = 'none' }) =>
{
    const up = () =>
    {
        return (
            <svg width={size} height={size} version="1.1" viewBox="0 0 700 700" xmlns="http://www.w3.org/2000/svg">
                <g>
                    <path d="m162.49 334.66c-13.453-13.453-11.773-35.316 3.3633-47.086 13.453-13.453 35.316-11.773 47.086 3.3633l75.676 87.449 215.25-267.39c26.906-33.633 60.539-11.773 33.633 23.543l-218.62 317.84-5.0469 5.0469c-15.137 13.453-35.316 11.773-48.77-3.3633l-102.58-119.4z" fill={color}/>
                </g>
            </svg>
        )
    }

    switch ( type )
    {
        case 'up' :
            return up() ;
        default:
            return up() ;
    }
}

export default Check ;

Check.propTypes = {
    type: PropTypes.string
};

